export interface IMessageFlash {
    message: string
    type: 'success' | 'warning' | 'info' | 'error'
}

export const MessageFlash = {
    add: ({ message, type }: IMessageFlash) => {
        import.meta.env.DEV && console.log('MessageFlash.add', { message, type })
        dispatchEvent(new CustomEvent<IMessageFlash>('ES_ADD_MESSAGE_FLASH', { detail: {
            message,
            type,
        } }))
    },

    addError: (message: string) => MessageFlash.add({ message, type: 'error' }),

    addSuccess: (message: string) => MessageFlash.add({ message, type: 'success' }),

    addWarning: (message: string) => MessageFlash.add({ message, type: 'warning' }),
}
